export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";